/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateScheduleTransferRequest } from '../models/CreateScheduleTransferRequest';
import type { ScheduleTransfer } from '../models/ScheduleTransfer';
import type { UpdateScheduleTransferStatusRequest } from '../models/UpdateScheduleTransferStatusRequest';
import { request as __request } from '../core/request';

export class ScheduleTransferService {

    /**
     * Create a schedule transfer request
     * @returns ScheduleTransfer Successfully created schedule transfer
     * @throws ApiError
     */
    public static async addScheduleTransfer({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: CreateScheduleTransferRequest,
}): Promise<ScheduleTransfer> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/schedule/transfer`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * status for schedule transfer
     * @returns ScheduleTransfer Successfully retrieved schedule transfers
     * @throws ApiError
     */
    public static async getScheduleTransfers({
companyId,
status,
}: {
/** The companyId **/
companyId: number,
/** The companyId **/
status?: string,
}): Promise<Array<ScheduleTransfer>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/transfer`,
            query: {
                'status': status,
            },
        });
        return result.body;
    }

    /**
     * Get a schedule transfer by id
     * @returns ScheduleTransfer Successfully retrieved schedule transfer
     * @throws ApiError
     */
    public static async getScheduleTransfer({
companyId,
scheduleId,
scheduleTransferId,
}: {
/** The companyId **/
companyId: number,
/** The scheduleId **/
scheduleId: number,
/** The scheduleTransferId **/
scheduleTransferId: number,
}): Promise<ScheduleTransfer> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/transfer/${scheduleTransferId}`,
            errors: {
                404: `The requested resource was not found`,
            },
        });
        return result.body;
    }

    /**
     * Delete a schedule transfer
     * @returns string Successfully deleted schedule transfer
     * @throws ApiError
     */
    public static async deleteScheduleTransfer({
companyId,
scheduleId,
scheduleTransferId,
}: {
/** The companyId **/
companyId: number,
/** The scheduleId **/
scheduleId: number,
/** The scheduleTransferId **/
scheduleTransferId: number,
}): Promise<string> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/schedule/transfer/${scheduleTransferId}`,
            errors: {
                404: `The requested resource was not found`,
            },
        });
        return result.body;
    }

    /**
     * Update a schedule transfer's status
     * @returns ScheduleTransfer Successfully updated schedule transfer status
     * @throws ApiError
     */
    public static async updateScheduleTransferStatus({
companyId,
scheduleId,
scheduleTransferId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The scheduleId **/
scheduleId: number,
/** The scheduleTransferId **/
scheduleTransferId: number,
requestBody: UpdateScheduleTransferStatusRequest,
}): Promise<ScheduleTransfer> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/schedule/transfer/${scheduleTransferId}/status`,
            body: requestBody,
        });
        return result.body;
    }

}